export default __webpack_public_path__ + "842ed2331cf7dcf4d96b5d4e55a76852.svg";